import {
  Components,
  stepIconClasses,
  stepLabelClasses,
  Theme,
} from '@mui/material';

export const getMuiStepLabel = (theme: Theme): Components['MuiStepLabel'] => ({
  styleOverrides: {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },

    iconContainer: {
      width: 32,
      height: 32,
      paddingRight: 0,
      marginBottom: theme.spacing(2),
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.palette.secondary.dark,
      color: theme.palette.grey[400],

      [`&.${stepLabelClasses.completed}, &.${stepLabelClasses.error}`]: {
        '&&': {
          backgroundColor: 'transparent',
        },
      },

      [`&.${stepLabelClasses.active}`]: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.background.paper,

        [`& .${stepLabelClasses.label}`]: {
          color: theme.palette.grey[900],
        },

        [`& .${stepIconClasses.root}`]: {
          color: theme.palette.background.paper,
        },

        [`& .${stepIconClasses.text}`]: {
          fill: theme.palette.background.paper,
        },
      },
    },

    label: {
      fontSize: 14,
      fontWeight: 700,
      color: theme.palette.grey[400],

      [`&.${stepLabelClasses.error}`]: {
        color: theme.palette.grey[900],
      },
    },
  },
});
